














































































































































































































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import { CSSStyleOptions } from '@libs-uuif/shared/common-types';
import UUIFComponents from '@/shared/uuifComponent';
import { SwIcon } from '@sonicwall/unified-ui-framework/src/shared/sw-icon';
import { SwSelect } from '@sonicwall/unified-ui-framework/src/shared/sw-select';
import { SwTextfield, SwTextarea } from '@libs-uuif/shared/sw-textfield';
import { SwModal ,  SwModalFooter , SwModalBody } from '@libs-uuif/shared/sw-modal';
import { SwRadio } from '@sonicwall/unified-ui-framework/src/shared/sw-radio';
import SupportFileUpload from './support-file-upload.vue';
import { currentUserKey } from './../../../shared/msw-constants';
import { SwToggle } from '@sonicwall/unified-ui-framework/src/shared/sw-toggle';
import { envCongif } from '@/shared/env.config';
import * as decode from 'jwt-decode';
// import MswAppTitle from '@/shared/msw-app-title/msw-app-title.vue';
import { CreateElement, VNode } from 'vue';
import axios from 'axios';
// import { values } from 'lodash';
const cssPrefix = 'support-cases-container';
@Component({
  components: {
    ...UUIFComponents,
    SwIcon,
    SwTextfield,
    SwRadio,
    SwToggle,
    SwModal,
    SwModalFooter,
    SwModalBody,
    SwTextarea,
    SwSelect,
    SupportFileUpload,
  },
})
export default class SupportCaseSlider extends SwExtendedVue {
  cssPrefix = cssPrefix;
  fileUploadModal: boolean = false;
  logFileDesc: string = '';
  logFileNote: string = '';
  disaplySerialNo: string = '';
  displayFriendlyName: string = '';
  pageNumber: string = '1';
  showWebChatBtn: boolean = false;
  showAiChatBtn: boolean = false;
  selectedProduct: string = 'default';
  serialNoList: any = [];
  serialNoListTemp: any = [];
  serialNo: string = 'ALL';
  supportSerialNumber: string = '';
  supportTitle: string = '';
  problemDesc: string = '';
  showPdfViewDialog: boolean = false;
  modifiedPdfUrl: string = '';
  envDetails: string = '';
  emailRadio: string = 'email';
  searchProduct: string = '';
  showSkeletonLoader: boolean = true;
  files: any = [];
  disableAccept: boolean = false;
  chatMessageFromAPi: string = '';
  showCancelBtn: boolean = false;
  productExpired: boolean = false;
  skeletonForIframe: boolean = false;
  showSerialNumField: boolean = false;
  showErrMsg1: boolean = false;
  showErrMsg2: boolean = false;
  showErrMsg3: boolean = false;
  submittedCaseDetails: any = {};
  awsUploadUrl: string = 'https://gddfubayy2x4xlj5r5xql3k3b40emdrj.lambda-url.us-west-2.on.aws/';
  showExpiredMaintain: boolean = false;
  serialNumberlist: any = [];
  endUserOrganizations: any = [];
  isPremierCaseUser: boolean = false;
  selectedEndUserOraganization: string = '';
  selectedProblemArea: string = 'selectOption';
  showProblemAreaErr: boolean = false;
  showDisclaimer: boolean = false;
  showTC: boolean = false;
  // problemAreaOpt: any = [
  //   { id: 'selectOption', value: 'Select Option', label: 'Select Problem Area' },
  //   { id: 'Registration', value: 'Registration', label: 'Registration' },
  //   { id: 'Licensing', value: 'Licensing', label: 'Licensing' },
  //   { id: 'MySonicWall.com', value: 'MySonicWall.com', label: 'MySonicWall.com' },
  //   { id: 'MSSP', value: 'MSSP', label: 'MSSP' },
  // ];
  problemAreaOptions: any = [
    { id: 'selectOption', value: 'Select Option', label: (this.$t('caseSeverityMsg.probLabel1')
      .toString()) },
    { id: 'Registration', value: 'Registration', label: (this.$t('caseSeverityMsg.probLabel2')
      .toString()) },
    { id: 'Licensing', value: 'Licensing', label: (this.$t('caseSeverityMsg.probLabel3')
      .toString()) },
    { id: 'MySonicWall.com', value: 'MySonicWall.com', label: (this.$t('caseSeverityMsg.probLabel4')
      .toString()) },
    { id: 'MSSP', value: 'MSSP', label: 'MSSP' },
  ];
  optedForPremierCase: boolean = false;
  showTitle: boolean = false;
  isSFDCCSuser: boolean = false;
  showWebChatPopup: boolean = false;
  showAiChatPopup: boolean = false;
  webChatUrl: string = '';
  webChatAiUrl: string = '';
  clickedServiceTicket: boolean = false;
  apiUrl: string = 'https://mswrestapi-blr-dev.eng.sonicwall.com/api';
  get overlayStyle(): CSSStyleOptions {
    return {
      width:'100%',
    };
  }
  get getPanelWidth() {
    const widthStyle: any = {
      width: '',
    };
    if (this.$route.query && this.$route.query.mode === 'APP') widthStyle.width = '100vw' ;
    else widthStyle.width = '50vw';
    return widthStyle;
  }
  private inputFieldInDropdown(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div id = "dropDownInput">
        <SwTextfield
          {...{
            props: {
              name: 'quote',
              value: this.searchProduct,
              placeholder: (this.$t('common.search')
              .toString()),
              ref: 'dropDownInputRef',
            },
            style: {
              width: '240px',
              margin: '2px auto',
            },
            on: {
              input: (event: any) => {
                this.searchProduct = event;
                this.applySearchFilters();
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  created() {
    const user: any = localStorage.getItem(currentUserKey);
    const snbUserRoles = JSON.parse(user).roles;
    // if (snbUserRoles.length !== 0 && snbUserRoles.includes('SFDCCHAT')) this.showWebChatBtn = true;
    if (snbUserRoles.length !== 0 && snbUserRoles.includes('SFDCCS')) this.isSFDCCSuser = true;
    if (this.$route.query && this.$route.query.mode === 'APP') {
      console.warn('checking route', this.$route.query.mode === 'APP');
      this.showTitle = true;
    } else {
      this.showTitle = false;
    }
    const currentUser = localStorage.getItem(currentUserKey);
    const token =  currentUser && JSON.parse(currentUser) ? JSON.parse(currentUser).token : '';
    const decodedToken : any = decode(token);
    this.isPremierCaseUser = decodedToken.psup && decodedToken.psup === 'YES' ? true : false;
    this.checkRoleFromAPi();
    this.$store.dispatch('getAppVersion')
    .then((result: any) => {
      this.webChatAiUrl = result.content.sfdcChatAIUrl;
      this.showAiChatBtn = this.webChatAiUrl.length ? true : false;
    });
  }
  checkRoleFromAPi() {
    this.$store.dispatch('MswSupportCasesModule/getChatDetails')
    .then((resp: any) => {
      this.showWebChatBtn = false;
      this.$store.commit('stopLoading');
      if (resp.msgCode === 'MSWAPP:CHATINSUFFICIENTROLES' || resp.msgCode === 'MSWAPP:UNSUPPORTEDCOUNTRY') {
        this.showWebChatBtn = false;
      } else {
        this.showWebChatBtn = true;
        this.handleOnClickWebChatLogin(resp);
      }

    });
  }
  submitCase() {
    this.pageNumber = '2';
    this.fetchEndUserOrganizations();
    this.$store.dispatch('MswSupportCasesModule/getSerialNumber', this.serialNo)
      .then((resp: any) => {
        console.warn(resp);
        this.serialNoList = [];
        this.serialNoListTemp = [];
        if (resp.msgCode === 'MSWAPP:EMPTYPRODLIST') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          // this.fetchEndUserOrganizations();
        } else if (resp.msgCode === 'MSWAPP:INVALIDSERIALNUMBER' || resp.msgCode === 'MSWAPP:NOSERIALNUMBERREGISTERED') {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          this.serialNoList[0] = { id: 'default', value: 'default', label: 'Select Product' };
          // this.serialNoList[1] = { id: 'openSrlNumSelector', value: 'openSrlNumSelector', label: 'Enter serial number manually' };
          // this.fetchEndUserOrganizations();
        } else {
          // tslint:disable-next-line
          this.serialNoList[0] = { id: 'inputField', value: 'inputField', label: (h: CreateElement) => {
            return this.inputFieldInDropdown(h);
          }  };
          this.serialNoList[1] = { id: 'default', value: 'default', label: 'Select Product' };
          if (resp.content.getrSerialNo.length > 0) {
            this.serialNumberlist = resp.content.getrSerialNo;
            // this.serialNoList[2] = { id: 'openSrlNumSelector', value: 'openSrlNumSelector', label: 'Enter serial number manually' };
            resp.content.getrSerialNo.forEach((data : any, i : any) => {
              const tempObject = {
                id: data.serialNo,
                value: data.serialNo,
                label: data.friendlyName,
              };
              this.serialNoList[i + 2] = tempObject;
              if (i === resp.content.getrSerialNo.length - 1) this.showSkeletonLoader = false;
            });
          }
          // else {
          //   this.fetchEndUserOrganizations();
          // }
        }
        this.serialNoListTemp = this.serialNoList;
      })
      .catch((errResponse: any) => {
        console.error(errResponse);
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Something went wrong.' });
      });
  }
  onClickServiceTicket() {
    this.clickedServiceTicket = true;
    this.pageNumber = '3';
  }
  handleOnClickWebChatLogin(resp: any = {}) {
    if (resp?.msgCode === 'MSWAPP:SUCCESS') this.disableAccept = false;
    else if (resp?.msgCode === 'MSWAPP:CHATOUTOFOFFICE') this.disableAccept = true;
    this.chatMessageFromAPi = resp?.msgDesc;
    this.showTC = resp?.content?.showTC === 'YES';
    this.showDisclaimer = this.showTC;
  }
  onClickWebChat() {
    this.showAiChatPopup = false;
    if (this.showTC) {
      this.$store.dispatch('MswSupportCasesModule/getChatDetails')
    .then((response: any) => {
      this.$store.commit('stopLoading');
      this.handleOnClickWebChatLogin(response);
    });
    } else this.getWebChatLink();
  }
  onClickAiChat() {
    this.showWebChatPopup = false;
    this.showAiChatPopup = true;
  }
  getWebChatFAQLink() {
    this.modifiedPdfUrl = `${window.location.origin}/help/chatfaq.pdf`;
    this.showPdfViewDialog = true;
  }
  getWebChatLink() {
    // const sessionID = JSON.parse(this.$store.getters.getUserInfo).user.sessionId;
    // console.warn(sessionID, btoa(sessionID));
    // const url = `/sfdcwebchat.aspx?I=${btoa(sessionID)}`;
    // return url;
    const request = {
      tenantId: 0,
      tileName: 'SFDCCHAT32232',
    };
    this.$store.dispatch('MswSupportCasesModule/getCSCScodeForWebChat', request)
      .then((response: any) => {
        this.$store.commit('stopLoading');
        if (response.operationStatus === 'OK') {
          this.$store.dispatch('getAppVersion')
          .then((result: any) => {
            console.warn(response);
            const eventMethod: any = window.addEventListener ? 'addEventListener' : 'attachEvent';
            const eventer: any = window[eventMethod];
            const messageEvent: any = eventMethod === 'attachEvent' ? 'onmessage' : 'message';
            // tslint:disable-next-line:align
            eventer(messageEvent, ((e: any) => {
              const key = e.message ? 'message' : 'data';
              const receivedEventMessage = e[key];
              console.warn('receivedEventMessage', receivedEventMessage);
              if (receivedEventMessage === 'showCancel') {
                console.warn('cancel btn check', receivedEventMessage);
                this.showCancelBtn = true;
              }
              // tslint:disable-next-line:align
            }),         false);
            console.warn('outside event');
            this.webChatUrl = `${result.content.sfdcChatUrl}${response.content.accessCode}`;
            this.showWebChatPopup = true;
            this.showDisclaimer = false;
            this.$store.commit('stopLoading');
            this.skeletonForIframe = true;
            setTimeout(() => {
              this.skeletonForIframe = false;
            },         3000);
          });
        } else if (response.operationStatus === 'NOK') {
          console.warn('cscc code NOK');
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
          this.showDisclaimer = false;
        }
        // this.webChatUrl = `https://sonicwall--uat.sandbox.my.salesforce-sites.com/SWChat?CODE=${response.content.accessCode}`;
        // this.webChatUrl = 'https://sonicwall--uat.sandbox.my.salesforce-sites.com/SWChat?CODE=NF8yNzIxNTg1OF4xMzM3RkJBNkIyOTE0NjU3QTU0Qzg1QTNDRDBDRjc3Mw==';
        // window.open(`https://sonicwall--uat.sandbox.my.salesforce-sites.com/SWChat?CODE=${response.content.accessCode}`, '_blank');
      });
  }
  fetchEndUserOrganizations() {
    this.$store.dispatch('MswSupportCasesModule/fetchEndUserOrganizations')
      .then((response: any) => {
        // this.$store.commit('stopLoading');
        if (response.msgCode === 'MSWAPP:GETPRIEMIERSUPPORTORGSUCCESS') {
          if (response.content && response.content.PremierSupportOrgList) {
            this.endUserOrganizations = [];
            response.content.PremierSupportOrgList.forEach((item: any) => {
              this.endUserOrganizations.push({
                id: item.orgId,
                value: item.orgName,
                label: item.orgName,
              });
            });
          }
          if (this.endUserOrganizations.length > 0) {
            this.selectedEndUserOraganization = this.endUserOrganizations[0].id;
          }
        }
      })
      .catch((err: any) => {
        console.error(err);
        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Something went wrong.' });
      });
  }
  // restriction textarea input length
  onSupportTitle(value: any) {
    this.showErrMsg1 = false;
    if (value) {
      this.supportTitle = value.length > 20 ? value.slice(0, 100) : value;
    }
  }
  goToHome() {
    window.parent.postMessage({
      goBackToDashboard : true,
    },                        '*');
  }
  onProlemDesc(value: any) {
    this.showErrMsg2 = false;
    if (value) {
      this.problemDesc = value.length > 2000 ? value.slice(0, 2000) : value;
    }
  }
  onEnvDetails(value: any) {
    this.showErrMsg3 = false;
    if (value) {
      this.envDetails = value.length > 2000 ? value.slice(0, 2000) : value;
    }
  }
  onOptedForPremierCase(val: boolean) {
    if (val) this.optedForPremierCase = true;
    else this.optedForPremierCase = false;
  }
  async createCase() {
    if (this.supportTitle === '') {
      this.showErrMsg1 = true;
    } else if (this.problemDesc === '') {
      this.showErrMsg2 = true;
    } else if (this.envDetails === '') {
      this.showErrMsg3 = true;
    } else if (this.clickedServiceTicket && this.selectedProblemArea === 'selectOption') {
      this.showProblemAreaErr = true;
    } else {
      const caseRequest: any = {
        caseDesc: this.problemDesc,
        caseTitle: this.supportTitle,
        envDetails: this.envDetails,
      };
      if (this.clickedServiceTicket) {
        caseRequest.caseType = 'CS';
        caseRequest.problemArea = this.selectedProblemArea;
      }
      if (!this.clickedServiceTicket) {
        caseRequest.contactMe = 'email';
        caseRequest.serialNo = this.selectedProduct === 'default' ? this.supportSerialNumber.trim() : this.selectedProduct;
      }
      if (this.optedForPremierCase && this.isPremierCaseUser && !this.clickedServiceTicket) {
        caseRequest.isPremiumCase = 'YES';
      }
      if (this.endUserOrganizations.length > 0 && !this.clickedServiceTicket) {
        caseRequest.premiumCaseOrgId = this.selectedEndUserOraganization;
      }
      this.$store.dispatch('MswSupportCasesModule/createCase', caseRequest)
        .then(async (resp: any) => {
          if (resp.msgCode === 'MSWAPP:SUCCESS') {
            this.submittedCaseDetails = resp.content;
            if (this.files.length > 0) {
              this.files.forEach(async (item: any) => {
                const currentUserToken: any = JSON.parse(localStorage.getItem(currentUserKey) as any).token;
                const payload = {
                  authToken: currentUserToken,
                  caseNo: this.submittedCaseDetails.caseId,
                  Mode: 'PUT',
                  env: envCongif.env,
                };
                try {
                  await axios.post(this.awsUploadUrl, payload, {
                    headers: {
                      'Content-Type': 'application/json',
                    },
                  })
                  .then((postRes: any) => {
                    if (postRes) {
                      const respString: any = postRes.data.split(',');
                      const config = {
                        onUploadProgress: (progressEvent: { loaded: number; total: number; }) => {
                          const completedPercent = (progressEvent.loaded / progressEvent.total) * 100;
                          item.doc.files[0].progress = completedPercent;
                        },
                        headers: {
                          'Content-Type': '',
                        },
                      };
                      axios.put(respString[1].substring(10), item.doc.files[0].file, config)
                      .then((putRes: any) => {
                        if (putRes.status === 200) {
                          // const caseNumber = this.caseDetails.caseno.toString();
                          // const downloadUrl = `${this.options.uploadUrl}/?caseno=${caseNumber}&sid=2222&filename=${this.selectedFile.name}`;
                          const payload = {
                            caseNumber: this.submittedCaseDetails.caseId,
                            caseId: this.submittedCaseDetails.caseNo,
                            descriptiveName: item.desc,
                            addNote: item.note,
                            fileName: respString[0].substring(9),
                            origFileName: item.doc.files[0].file.name,
                          };
                          try {
                            this.$store.dispatch('MswSupportCasesModule/uploadSupportAttachment', payload)
                            .then((response: any) => {
                              if (response.msgCode === 'MSWAPP:SUCCESS') {
                                let isUploadIsDone: boolean = false;
                                this.files.every((file: any) => {
                                  if (file.doc.files[0].progress === 100) {
                                    isUploadIsDone = true;
                                  } else {
                                    isUploadIsDone = false;
                                  }
                                  if (!isUploadIsDone) return false;
                                });
                                if (isUploadIsDone) {
                                  this.$store.commit('stopLoading');
                                  this.pageNumber = '4';
                                }
                              } else {
                                this.$store.commit('stopLoading');
                                this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: response.msgDesc });
                              }
                            });
                          } catch (err) {
                            this.$store.commit('stopLoading');
                            this.pageNumber = '4';
                            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Something went wrong.' });
                            console.error(err);
                          }
                        }
                      })
                      .catch((e: any) => {
                        console.error(e);
                        this.$store.commit('stopLoading');
                        this.pageNumber = '4';
                        this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Failed to upload attachment. please try again' });
                      });
                    }
                  });
                } catch (e) {
                  console.warn('error', e);
                  this.$store.commit('stopLoading');
                  this.pageNumber = '4';
                  this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: 'Failed to upload attachment, please try after sometime' });
                }
              });
            } else {
              this.$store.commit('stopLoading');
              this.pageNumber = '4';
            }
          } else {
            this.$store.commit('stopLoading');
            this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
          }
        });
    }
  }
  applySearchFilters() {
    if (this.searchProduct !== '') {
      const key = this.searchProduct.toUpperCase();
      this.serialNoListTemp = [];
      this.serialNoListTemp = this.serialNoList.filter((item : any, i: number) => {
        if (i > 2 && item['label'] && (item['label'].toUpperCase()).indexOf(key) >= 0) {
          return true;
        }
      });
      this.serialNoListTemp.unshift({ id: 'inputField', value: 'inputField', label: (h: CreateElement) => {
        return this.inputFieldInDropdown(h);
      }  },
      );
    } else {
      this.serialNoListTemp = this.serialNoList;
    }
  }
  onSelectOrganization() {
    console.warn(this.selectedEndUserOraganization);
  }
  // onClickDropDown() {
  // }
  onSelectProductClick() {
    const inputOption = document.getElementById('dropDownInput') as HTMLElement;
    if (inputOption) {
      inputOption.children[0]
        .getElementsByTagName('input')[0]
        .focus();
    }
    const dropdownEl: any = this.$refs.selectProductDropdown as HTMLElement;
    if (dropdownEl?.isDropdownVisible) {
      const dropdownInput = document.querySelector('#dropDownInput');
      dropdownInput?.addEventListener('click', (e) => {
        e.stopPropagation();
      });
    }
  }
  onSelectProduct(val: any) {
    this.supportSerialNumber = '';
    this.serialNoListTemp = this.serialNoList;
    this.searchProduct = '';
    if (val !== 'inputField') {
      this.showExpiredMaintain = false;
      this.selectedProduct = val;
      // if (this.selectedProduct === 'openSrlNumSelector') this.showSerialNumField = true;
      // else this.showSerialNumField = false;
    }
  }
  onEnterSerialNo(event : any) {
    if (this.supportSerialNumber !== '') {
      this.selectedProduct = 'default';
      this.showExpiredMaintain = false;
      // this.serialNumberlist.forEach((item: any) => {
      //   if (item.serialNo === this.supportSerialNumber) this.selectedProduct = item.serialNo;
      // });
      if (event.keyCode === 13) {
        this.onClickNext();
      }
    }
  }
  onClickNext() {
    let isExpired: boolean = false;
    if (this.supportSerialNumber !== '') {
      this.$store.commit('startLoading');
      this.$store.dispatch('MswSupportCasesModule/getSerialNumber', this.supportSerialNumber.trim())
      .then((resp: any) => {
        this.$store.commit('stopLoading');
        if (resp.msgCode === 'MSWAPP:SUCCESS') {
          if (resp.content.getrSerialNo[0].isExpired) isExpired = true;
          this.disaplySerialNo = resp.content.getrSerialNo[0].serialNo;
          this.displayFriendlyName = resp.content.getrSerialNo[0].friendlyName;
        } else {
          this.$store.commit('enqueueMessage', { infoType: 'failed', infoMsg: resp.msgDesc });
        }
        if (isExpired && resp.msgCode === 'MSWAPP:SUCCESS') this.showExpiredMaintain = true;
        else if (!isExpired && resp.msgCode === 'MSWAPP:SUCCESS') {
          this.pageNumber = '3';
        }
      });
    } else if (this.selectedProduct !== 'default') {
      this.serialNumberlist.forEach((item: any) => {
        if (item.serialNo === this.selectedProduct && item.isExpired) {
          isExpired = true;
        }
        if (item.serialNo === this.selectedProduct) {
          this.disaplySerialNo = item.serialNo;
          this.displayFriendlyName = item.friendlyName;
        }
      });
      if (isExpired) this.showExpiredMaintain = true;
      else this.pageNumber = '3';
    }
  }
  severityLinkClick() {
    window.open('https://www.sonicwall.com/en-us/support/support-services', '_blank');
  }
  tsSeverityLink() {
    window.open('https://www.sonicwall.com/en-us/support/contact-support', '_blank');
  }
  closeFileUpload() {
    this.fileUploadModal = false;
  }
  selectedFiles(val: any) {
    this.files.push(val);
  }
  onCloseSlide() {
    if (this.$route.query && this.$route.query.mode === 'APP') {
      console.warn('checking route', this.$route.query.mode === 'APP');
      // window.parent.postMessage({
      //   closeSupportSlider : true,
      // },                        '*');
    } else {
      this.$emit('closeSlider');
    }
  }
  onClickCaseNumber() {
    if (this.$route.query && this.$route.query.mode === 'APP') {
      console.warn('checking mode', this.$route.query.mode);
      window.parent.postMessage({
        newCaseCreated : true,
      },                        '*');
    } else {
      if (this.$route.path !== '/m/feature/managecases') {
        this.$router.push({ path: '/m/feature/managecases', query: { newCase: 'created' } });
      } else {
        this.$emit('onClickNewlyCreatedCase');
      }
      this.$emit('closeSlider');
    }
    this.pageNumber = '1';
  }
  navigateToManageCases() {
    if (this.$route.query && this.$route.query.mode === 'APP') {
      console.warn('checking route', this.$route.query.mode === 'APP');
      window.parent.postMessage({
        navigateToManageCases : true,
      },                        '*');
    } else {
      if (this.$route.path !== '/m/feature/managecases') this.$router.push({ path:'/m/feature/managecases' });
      this.$emit('closeSlider');
    }
  }
  closeIframe() {
    this.showWebChatPopup = false;
    this.showAiChatPopup = false;
    this.showCancelBtn = false;
  }
  backToFirstPage() {
    this.selectedProduct = 'default';
    this.supportSerialNumber = '';
    this.showExpiredMaintain = false;
    this.showSerialNumField = false;
    this.disaplySerialNo = '';
    this.displayFriendlyName = '';
    this.supportTitle = '';
    this.problemDesc = '';
    this.envDetails = '';
    this.pageNumber = '1';
    this.showErrMsg1 = this.showErrMsg2 = this.showErrMsg3 = false;
    this.showProblemAreaErr = false;
    this.selectedProblemArea = 'selectOption';
    this.files = [];
    this.clickedServiceTicket = false;
  }
}
